import * as React from 'react'
import { useOutletContext, useParams } from 'react-router-dom'

import { Box, Title } from '@factorialco/deprecated-design-system'

import Loading from 'modules/core/components/Loading'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import i18n from 'modules/core/lib/i18n'
import { employeeUser } from 'modules/core/store/collections/users'

import { CommonRouteContext } from 'modules/employees/lib/types'
import Page from 'modules/layout/components/Page'
import ReviewsTable from 'modules/reviews/components/Employees/Reviews/Table/Table'
import questionGroups from 'modules/reviews/store/collections/questionGroups'
import reviews from 'modules/reviews/store/collections/v2/reviews'
import groups from 'modules/surveys/store/collections/groups'

export default function EmployeeReviewsIndexPage() {
  const { employee } = useOutletContext<CommonRouteContext>()

  const { id } = useParams()
  const revieweeId = employeeUser(employee)?.attributes.id

  const { loading } = useAsyncData(() => {
    return Promise.all([
      reviews.fetch({
        data: {
          reviewee_id: revieweeId,
        },
      }),
      questionGroups.fetch({
        data: {
          open: true,
          target_id: revieweeId,
        },
      }),
      groups.fetch(),
    ])
  }, [id])

  const filteredReviews = reviews.models.filter((review) => !review.isDraft)

  return (
    <Page.Body>
      <Box gap="s32">
        <Title
          illustration="surveys"
          title={i18n.t('surveys.employee.performance.title')}
          description={i18n.t('surveys.employee.performance.description')}
        />
        {loading ? (
          <Loading />
        ) : (
          <ReviewsTable
            employee={employee}
            forms={filteredReviews}
            questionGroups={questionGroups.models}
          />
        )}
      </Box>
    </Page.Body>
  )
}
